module.exports = __webpack_public_path__ + "static/media/teke-k-eyes.69f54ddf.jpg";